// extracted by mini-css-extract-plugin
module.exports = {"WrapperAnnotation":"seoDescriptionBlock_WrapperAnnotation__Yhs1I","isArray":"seoDescriptionBlock_isArray__3wcGy"};